var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Grid from '../grid';
import GridColumn from '../grid/column';
import GridRow from '../grid/row';
import { Styled } from './style';
import Cover from './img/no-apps-installed.png';
var EmptyStateAppsInstalled = /** @class */ (function (_super) {
    __extends(EmptyStateAppsInstalled, _super);
    function EmptyStateAppsInstalled() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmptyStateAppsInstalled.prototype.render = function () {
        return (React.createElement(Styled, null,
            React.createElement(Grid, { textAlign: "center" },
                React.createElement(GridRow, null,
                    React.createElement(GridColumn, null,
                        React.createElement("img", { src: Cover, alt: "cover", className: "cover" }))),
                React.createElement(GridRow, null,
                    React.createElement(GridColumn, null,
                        React.createElement("h3", null,
                            React.createElement(FormattedMessage, { id: "apps.get_started", defaultMessage: "Look familiar?" })),
                        React.createElement("p", null,
                            React.createElement(FormattedMessage, { id: "apps.no_apps_blurb_main", defaultMessage: "The App Store helps you make screen-ready content from places where your content already lives." }),
                            React.createElement("br", null),
                            React.createElement(FormattedMessage, { id: "apps.no_apps_blurb_subtext", defaultMessage: "There are 73 apps right now, and more coming all the time." })),
                        this.props.children)))));
    };
    return EmptyStateAppsInstalled;
}(React.Component));
export default EmptyStateAppsInstalled;
//# sourceMappingURL=index.js.map